module.exports = __webpack_public_path__ + "static/media/proces_02.b90510be.svg";